import { render, staticRenderFns } from "./view.vue?vue&type=template&id=0ef6beaa"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style0 from "./view.vue?vue&type=style&index=0&id=0ef6beaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports